import './registerServiceWorker'
import Vue from 'vue';
import VueRouter from 'vue-router';

import moment from 'moment'
import VueMoment from 'vue-moment'
moment.locale('it')

import vueMoment from 'vue-moment'

import RouterPrefetch from 'vue-router-prefetch'

import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';
import Filters from './filters'

// router setup
import router from './routes/router'
import i18n from './i18n'
import { store } from '@/store/store'

// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueRouter);
Vue.use(RouterPrefetch);
Vue.use(vueMoment,{
	moment
});
Vue.use(Filters)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  render: h => h(App),
  router,
  i18n
});
